import styled from 'styled-components';
import { Drawer } from 'antd';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    display: flex;
    flex-direction: column;
    .ant-drawer-header-title {
      display: flex;
      width: 100%;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      & > button {
        margin-right: 0;
        margin-left: 8px;
      }
      .ant-drawer-title {
        margin: 0;
      }
    }
    .ant-drawer-extra {
      align-self: start;
    }
  }
`;
